export const environment = {
  production: false,
  apiEndpoint: "https://93bwj2qcwe.execute-api.eu-west-3.amazonaws.com/",
  auth: { oidc: {
    authority: "https://ciam-ileo-hom.mel-ileo.fr/realms/sbvp",
    issuer: "https://ciam-ileo-hom.mel-ileo.fr/realms/sbvp",
    clientId: "hom-sbvp-from",
    keycloakApiAudience: "cmc-api",
    redirectUri: window.location.origin + '/',
    logoutRedirectUri: window.location.origin + '/',
    scope: 'openid profile email', responseType: 'code',
    silentRenew: true, useRefreshToken: true,
  } },
};
